import { graphql } from '@gql';

export const VildarCardSectionFragment = graphql(/* GraphQL */ `
  fragment VildarCardSectionFragment on VildarPageComponentsCards {
    __typename
    cards {
      card_sectionConnection {
        edges {
          __typename
          node {
            ...VildarCardSectionCardsFragment
          }
        }
      }
    }
  }
`);

export const VildarCardSectionCardsFragment = graphql(/* GraphQL */ `
  fragment VildarCardSectionCardsFragment on VildarCardSection {
    __typename
    title
    display_title

    ...CardSectionSimpleBoxesFragment
    sidebar
    post_limit
    ...CardSectionPersonsFragment
    paragraph
    pagination
    link {
      external_url {
        href
        title
      }
      internal_urlConnection {
        edges {
          node {
            ... on VildarPage {
              navigation_title
              url
            }
          }
        }
      }
      label
    }
    type
    card_template
  }
`);

export const CardSectionSimpleBoxesFragment = graphql(/* GraphQL */ `
  fragment CardSectionSimpleBoxesFragment on VildarCardSection {
    simple_boxes {
      ... on VildarCardSectionSimpleBoxesBox {
        __typename
        box {
          background_color
          headline
          text
        }
      }
    }
  }
`);

export const CardSectionPersonsFragment = graphql(/* GraphQL */ `
  fragment CardSectionPersonsFragment on VildarCardSection {
    persons {
      ... on VildarCardSectionPersonsPerson {
        __typename
        person {
          description
          name
          image {
            alt_text
            crop_resize
            gravity
            assetConnection {
              edges {
                node {
                  dimension {
                    height
                    width
                  }
                  system {
                    uid
                  }
                  content_type
                }
              }
            }
          }
        }
      }
    }
  }
`);
